import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { useBottomSheet } from '../../../../state-management/contexts/BottomSheetContext'
import { lightImpactVibrate } from '../../../../utils/appBridge'

import { ElssAlternativesBottomSheet } from '../../bottom-sheets/ElssAlternativesBottomSheet'
import {
  TaxHarvestingScreenName,
  TaxHarvestingEventId,
  trackTaxHarvestingUserClicked
} from '../../tracking/taxHarvestingTracking'

export function ELSSCallout() {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  const handleViewAlternatives = () => {
    trackTaxHarvestingUserClicked({
      screen: TaxHarvestingScreenName.Recommendation,
      eventId: TaxHarvestingEventId.ElssViewAlternatives
    })
    lightImpactVibrate?.()
    openBottomSheet(<ElssAlternativesBottomSheet onDismiss={closeBottomSheet} />)
  }

  return (
    <div onClick={handleViewAlternatives}
      className="flex gap-3 pt-3 pb-[14px] pr-3 pl-6 rounded-[12px] border border-[#CBF7D7]">
      <div className="mt-[6px]">
        <RenderHTML innerHTMLText={InfoIcon} />
      </div>
      <div className="flex-1 text-[13px] font-[400] text-[#6A6E6E] leading-[150%]">
        New tax regime doesn&apos;t offer deductions for ELSS investments.{' '}
        <span
          className="text-[#232323] cursor-pointer font-[500] underline"

        >
          View alternatives
        </span>
      </div>
    </div>
  )
}

export const InfoIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_71014_461109)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 16C13.3019 16 16 13.3019 16 8C16 2.69807 13.3019 0 8 0C2.69807 0 0 2.69807 0 8C0 13.3019 2.69807 16 8 16Z" fill="#CBF7D7"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.37667 10.2069C6.00306 10.2069 5.7002 10.5023 5.7002 10.8667C5.7002 11.2312 6.00306 11.5266 6.37667 11.5266H9.62372C9.99733 11.5266 10.3002 11.2312 10.3002 10.8667C10.3002 10.5023 9.99733 10.2069 9.62372 10.2069H8.67667V7.17164C8.67667 6.80722 8.3738 6.51181 8.0002 6.51181H6.91784C6.54424 6.51181 6.24137 6.80722 6.24137 7.17164C6.24137 7.53606 6.54424 7.83148 6.91784 7.83148H7.32372V10.2069H6.37667ZM9.08255 4.5323C9.08255 5.11536 8.59796 5.58804 8.0002 5.58804C7.40243 5.58804 6.91784 5.11536 6.91784 4.5323C6.91784 3.94924 7.40243 3.47656 8.0002 3.47656C8.59796 3.47656 9.08255 3.94924 9.08255 4.5323Z" fill="#00661D"/>
  </g>
  <defs>
    <clipPath id="clip0_71014_461109">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>`
